import { useNavigate } from "react-router-dom";

export default function Landing() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-[#FAF7F5] text-[#3F3F3F] overflow-hidden">
      {/* NAV */}
      <nav className="px-5 py-5 flex justify-between items-center">
        <span className="text-base font-semibold text-[#7B4156]">
          this week
        </span>
        <button
          onClick={() => navigate("/app")}
          className="text-sm text-[#7B4156]/70"
        >
          Open
        </button>
      </nav>

      {/* HERO */}
      <section className="relative max-w-6xl mx-auto px-6 pt-24 pb-32 min-h-[70vh] flex items-center">
        <div className="grid lg:grid-cols-2 gap-16 items-center w-full">
          {/* LEFT – TEXT */}
          <div className="text-center lg:text-left animate-fade-in-up">
            <h1 className="text-4xl md:text-5xl font-semibold leading-tight text-[#7B4156]">
              A calmer way
              <br className="hidden lg:block" />
              {" "}
              to move through your{" "}
              <span className="bg-gradient-to-r from-[#7B4156] to-[#A56A7C] bg-clip-text text-transparent">
                week
              </span>
            </h1>

            <p className="mt-6 text-lg text-gray-600 max-w-md mx-auto lg:mx-0">
              Not a to-do list.
              <br />
              Not a habit tracker.
              <br />
              Just a gentle space for this week.
            </p>

            <p className="mt-4 text-xs text-gray-400">It changes with you.</p>

            <button
              onClick={() => navigate("/app")}
              className="mt-10 px-6 py-3 rounded-xl bg-[#7B4156] text-white text-sm animate-fade-in-delay"
            >
              Start your week
            </button>
          </div>

          {/* RIGHT – DESKTOP BLOB */}
          <div className="hidden lg:flex justify-center relative">
            <div
              className="w-[360px] h-[360px] rounded-full
                bg-gradient-to-br from-[#7B4156]/30 via-[#E6B8C5]/40 to-[#7B4156]/20
                blur-3xl animate-blob
              "
            />
          </div>
        </div>
      </section>

      {/* HOW IT WORKS */}
      <section className="max-w-6xl mx-auto px-6 pb-32">
        <div className="grid md:grid-cols-3 gap-8">
          {[
            {
              step: "01",
              title: "Choose your focus",
              desc: "Add a few things you want to show up for this week.",
            },
            {
              step: "02",
              title: "Return daily",
              desc: "See only what matters today. No noise.",
            },
            {
              step: "03",
              title: "Carry it forward",
              desc: "Weeks roll over gently. Nothing is lost.",
            },
          ].map((item) => (
            <div
              key={item.step}
              className="bg-white rounded-2xl p-5 shadow-sm transition-transform duration-300 hover:-translate-y-0.5"
            >
              <span className="text-xs text-gray-400">
                {item.step}
              </span>
              <h3 className="mt-1 text-[#7B4156] font-medium">
                {item.title}
              </h3>
              <p className="mt-1 text-sm text-gray-600">
                {item.desc}
              </p>
            </div>
          ))}
        </div>
      </section>

      {/* DIFFERENCE */}
      <section className="bg-white px-5 py-20 text-center">
        <h2 className="text-2xl font-semibold text-[#7B4156]">
          Designed for continuity,
          <br /> not pressure
        </h2>

        <div className="mt-14 grid gap-6 sm:grid-cols-2 lg:grid-cols-4">
          {[
            {
              title: "No due dates",
              desc: "No alarms. No countdowns. No pressure.",
            },
            {
              title: "Gentle resets",
              desc: "Each week begins fresh, without guilt.",
            },
            {
              title: "Nothing is lost",
              desc: "Archive instead of deleting progress.",
            },
            {
              title: "Quiet progress",
              desc: "Growth that doesn’t ask for attention.",
            },
          ].map((item) => (
            <div
              key={item.title}
              className="
        bg-white rounded-3xl p-6
        shadow-[0_8px_30px_rgba(0,0,0,0.04)]
        transition-all duration-300
        hover:-translate-y-1 hover:shadow-[0_12px_40px_rgba(0,0,0,0.06)]
      "
            >
              {/* soft accent */}
              <div className="w-8 h-1 rounded-full bg-[#E6B8C5] mb-4" />

              <h4 className="text-[#7B4156] font-medium mb-2">
                {item.title}
              </h4>
              <p className="text-sm text-gray-600 leading-relaxed">
                {item.desc}
              </p>
            </div>
          ))}
        </div>
      </section>

      {/* CTA */}
      <section className="px-5 py-24 text-center">
        <h3 className="text-xl font-medium text-[#7B4156]">
          Start with one calm week
        </h3>
        <p className="mt-2 text-sm text-gray-600">
          That’s enough.
        </p>

        <button
          onClick={() => navigate("/app")}
          className="mt-6 px-6 py-3 rounded-xl bg-[#7B4156] text-white text-sm"
        >
          Open the app
        </button>
      </section>

      {/* FOOTER */}
      <footer className="text-center text-xs text-gray-400 pb-8">
        Built for gentle consistency.
      </footer>
    </div>
  );
}
